
// Switch between dev and production automatically
const BASE_URL = process.env.NODE_ENV === "production"
  ? "https://app.radheshyamhotels.com/"   // ← live backend
  : "https://app.radheshyamhotels.com/";               // ← local backend

export default BASE_URL;
